export default __webpack_public_path__ + "static/media/logo.84998ea0.png";